<modal-hoc
    modalTitle="Confirm notification email"
    submitText="Confirm"
    [modalTheme]="modalTheme"
    (modalSubmit)="onModalSubmit($event)"
    (modalCancel)="onModalCancel($event)">
    <form [formGroup]="notificationAddressForm">
        <p>Send email when export has successfully pushed to <strong>{{ derivedChannelDestination }}</strong>.</p>
        <p>Please confirm this is correct before proceeding.</p>

        <fdx-form-field
            formControlName="notificationAddress">
            <fdx-input
                inputType="text"
                labelText="Feedonomics email"
                [inputGroupLeftAddons]="[leftIcon]"
                [inputGroupRightAddons]="[rightText]"/>
        </fdx-form-field>
        <ng-template #leftIcon>
            <span class="input-group-text">
                <fa-icon [icon]="iconEnvelope" aria-label="Envelope"></fa-icon>
            </span>
        </ng-template>
        <ng-template #rightText>
            <span class="input-group-text">&#64;feedonomics.com</span>
        </ng-template>
    </form>
</modal-hoc>
